// extracted by mini-css-extract-plugin
module.exports = {"magazineTitle":"DigitizedMagazine_magazineTitle__3suFn","headerImg":"DigitizedMagazine_headerImg__1Wjlx","magazineDescWrapper":"DigitizedMagazine_magazineDescWrapper__2tyqh"};